<div *ngIf="!loading && !dataSource?.data?.length" class="flex flex-col items-center justify-center">
  <img src="../../assets/img/empty.png" [alt]="message" class="my-8">
  <span data-test="no-data-table" class="body-b2 text-width text-center mb-8">{{message}}</span>
</div>
<div *ngIf="loading" class="flex flex-col items-center justify-center mb-12">
  <mat-progress-spinner mode="indeterminate" color="accent" class="my-12"></mat-progress-spinner>
</div>
<ng-content *ngIf="!loading && dataSource.data.length"></ng-content>
